import { isBelowiOS26 } from '@/lib/utils/iosCompat'
import { useTheme } from '@react-navigation/native'
import { NativeStackNavigationOptions } from '@react-navigation/native-stack'
import { Stack } from 'expo-router'
import { Platform } from 'react-native'

export default function FormsLayout() {
  const theme = useTheme()

  return (
    <Stack
      screenOptions={{
        title: '',
        headerLargeTitle: true,
        headerShadowVisible: false,
        headerBackButtonDisplayMode: 'minimal',
        contentStyle: { backgroundColor: theme.colors.background },
        ...Platform.select<NativeStackNavigationOptions>({
          ios: {
            headerTransparent: isBelowiOS26 ? false : true,
          },
          android: {
            headerTransparent: false,
            headerStyle: { backgroundColor: theme.colors.background },
          },
        }),
      }}
    >
      <Stack.Screen name="index" options={{ title: '表单' }} />
    </Stack>
  )
}
